export interface BgmTrack {
  id: number;
  name: string;
  file: string;
  price: number;
  unlocked: boolean;
}

export const bgmList: BgmTrack[] = [
  { id: 1, name: 'BGM 1', file: 'bgm1.mp3', price: 0, unlocked: true },
  { id: 2, name: 'BGM 2', file: 'bgm2.mp3', price: 3, unlocked: false },
  { id: 3, name: 'BGM 3', file: 'bgm3.mp3', price: 3, unlocked: false },
];